import React from 'react';
import { omit } from 'lodash';
import Grid from '@lendi-ui/grid';

import { FREQUENCY } from '@funnels/constants';

import { FullWidth } from '../../../_common';
import { FieldLabel } from '../../../Fields';
import { FunnelViewProps } from '../../types';
import { NeedsAndAnalysisCommon } from '../NeedsAndAnalysisCheckboxVariationCustomerView';
import { EstimatedImpactAmount } from './EstimatedImpactAmount';
import { EstimatedImpactFrequency } from './EstimatedImpactFrequency';

interface NeedsAndAnalysisEstimatedImpactTeamViewProps extends FunnelViewProps {
  amount: NeedsAndAnalysisCommon;
  frequency: Omit<NeedsAndAnalysisCommon, 'label'>;
}

export const NeedsAndAnalysisEstimatedImpactTeamView: React.FC<NeedsAndAnalysisEstimatedImpactTeamViewProps> = (
  props
) => {
  const { amount, frequency, isDisabled } = props;

  return (
    <FullWidth>
      <FieldLabel label={amount.label} isOptional={isDisabled} />
      <Grid gutter="sm" wrap={{ xs: false }} valign="top">
        <Grid.Unit size={2 / 3}>
          <EstimatedImpactAmount {...omit(amount, ['label'])} isDisabled={isDisabled} />
        </Grid.Unit>

        <Grid.Unit size={1 / 3}>
          <EstimatedImpactFrequency
            {...frequency}
            isDisabled={isDisabled}
            // set up defaultValue as disable will make the form become dirty so this logic is to prevent wrong dirty status of form
            defaultValue={isDisabled ? undefined : FREQUENCY.MONTHLY}
          />
        </Grid.Unit>
      </Grid>
    </FullWidth>
  );
};
